import { Component } from '@angular/core';

@Component({
  selector: 'conn-blank',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.css'],
})
export class BlankComponent {
  constructor() {}
}
